function t(r) {
  return r == null ? [] : Array.isArray(r) ? r : [r];
}
function a(r) {
  return r && !!r._init;
}
export {
  a as isFormInstance,
  t as toArray
};
//# sourceMappingURL=typeUtil.mjs.map
